// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .messagesWrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
:host .messagesWrapper app-event-message {
  overflow: hidden;
  opacity: 0;
}
:host .messagesWrapper app-event-message:not(:empty) {
  animation: notificationAnim 6s ease-out 0s 1 normal forwards running;
}
:host .messagesWrapper app-event-message:not(:empty):nth-child(2) {
  animation: notificationAnim 6s ease-out 1s 1 normal forwards running;
}
:host .messagesWrapper app-event-message:not(:empty):nth-child(3) {
  animation: notificationAnim 6s ease-out 2s 1 normal forwards running;
}
:host .messagesWrapper app-event-message:not(:empty):nth-child(4) {
  animation: notificationAnim 6s ease-out 3s 1 normal forwards running;
}
:host .messagesWrapper app-event-message:not(:empty):nth-child(5) {
  animation: notificationAnim 6s ease-out 4s 1 normal forwards running;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.shot {
  height: 20px !important;
  width: 20px !important;
  background-color: rgba(61, 146, 61, 0.8);
  border: 4px solid #FFF;
  box-shadow: none;
  z-index: 500 !important;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.shot.failed {
  background-color: rgba(174, 177, 185, 0.8);
  z-index: 499 !important;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.shot.live {
  box-shadow: 0 0 0 0 rgba(61, 146, 61, 0.5);
  animation: shotMade 6s linear 0s 1 normal forwards running;
}
@keyframes notificationAnim {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  95% {
    opacity: 0;
    height: auto;
    min-height: 32px;
    max-height: 120px;
  }
  100% {
    opacity: 0;
    height: 0;
    min-height: 0;
    max-height: 0;
  }
}
@keyframes shotMade {
  0% {
    box-shadow: 0 0 0 0 rgba(61, 146, 61, 0.5);
  }
  20% {
    box-shadow: 0 0 0 10px rgba(61, 146, 61, 0.5);
  }
  40% {
    box-shadow: 0 0 0 20px rgba(61, 146, 61, 0.2);
  }
  90% {
    box-shadow: 0 0 0 28px rgba(61, 146, 61, 0.1);
  }
  100% {
    box-shadow: 0 0 0 30px rgba(61, 146, 61, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/map/map-raw/map-raw.component.scss"],"names":[],"mappings":"AAKE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;AAJJ;AAMI;EACE,gBAAA;EACA,UAAA;AAJN;AAMM;EACE,oEAAA;AAJR;AAMQ;EACE,oEAAA;AAJV;AAOQ;EACE,oEAAA;AALV;AAQQ;EACE,oEAAA;AANV;AASQ;EACE,oEAAA;AAPV;AAcI;EACE,uBAAA;EACA,sBAAA;EACA,wCAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;AAZN;AAcM;EACE,0CAAA;EACA,uBAAA;AAZR;AAeM;EACE,0CAAA;EACA,0DAAA;AAbR;AAkBE;EACE;IACE,UAAA;EAhBJ;EAkBE;IACE,UAAA;EAhBJ;EAkBE;IACE,UAAA;EAhBJ;EAkBE;IACE,UAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;EAhBJ;EAkBE;IACE,UAAA;IACA,SAAA;IACA,aAAA;IACA,aAAA;EAhBJ;AACF;AAmBE;EACE;IACE,0CAAA;EAjBJ;EAmBE;IACE,6CAAA;EAjBJ;EAmBE;IACE,6CAAA;EAjBJ;EAmBE;IACE,6CAAA;EAjBJ;EAmBE;IACE,2CAAA;EAjBJ;AACF","sourcesContent":["@import 'theme';\n\n$notificationTime: 6s;\n\n:host {\n  .messagesWrapper {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1000;\n\n    app-event-message {\n      overflow: hidden;\n      opacity: 0;\n\n      &:not(:empty) {\n        animation: notificationAnim $notificationTime $animationFuncDefault 0s 1 normal forwards running;\n\n        &:nth-child(2) {\n          animation: notificationAnim $notificationTime $animationFuncDefault 1s 1 normal forwards running;\n        }\n\n        &:nth-child(3) {\n          animation: notificationAnim $notificationTime $animationFuncDefault 2s 1 normal forwards running;\n        }\n\n        &:nth-child(4) {\n          animation: notificationAnim $notificationTime $animationFuncDefault 3s 1 normal forwards running;\n        }\n\n        &:nth-child(5) {\n          animation: notificationAnim $notificationTime $animationFuncDefault 4s 1 normal forwards running;\n        }\n      }\n    }\n  }\n\n  #map ::ng-deep .leaflet-marker-icon.marker {\n    &.shot {\n      height: 20px !important;\n      width: 20px !important;\n      background-color: transparentize($colorLive, 0.2);\n      border: 4px solid $colorWhite;\n      box-shadow: none;\n      z-index: 500 !important;\n\n      &.failed {\n        background-color: transparentize($colorN30, 0.2);\n        z-index: 499 !important;\n      }\n\n      &.live {\n        box-shadow: 0 0 0 0 transparentize($colorLive, .5);\n        animation: shotMade 6s $animationFuncAlt 0s 1 normal forwards running;\n      }\n    }\n  }\n\n  @keyframes notificationAnim {\n    0% {\n      opacity: 0;\n    }\n    5% {\n      opacity: 1;\n    }\n    90% {\n      opacity: 1;\n    }\n    95% {\n      opacity: 0;\n      height: auto;\n      min-height: 32px;\n      max-height: 120px\n    }\n    100% {\n      opacity: 0;\n      height: 0;\n      min-height: 0;\n      max-height: 0;\n    }\n  }\n\n  @keyframes shotMade {\n    0% {\n      box-shadow: 0 0 0 0 transparentize($colorLive, .5);\n    }\n    20% {\n      box-shadow: 0 0 0 10px transparentize($colorLive, .5);\n    }\n    40% {\n      box-shadow: 0 0 0 20px transparentize($colorLive, .8);\n    }\n    90% {\n      box-shadow: 0 0 0 28px transparentize($colorLive, .9);\n    }\n    100% {\n      box-shadow: 0 0 0 30px transparentize($colorLive, 1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
